import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useSelector } from 'react-redux';

import { CoreLink } from '@uncinc/react-drupal-core';

import {
  BuurtboerderijMenuFooter,
} from '../../../implementations';

import './style.scss';

const BuurtboerderijFooter = ({ entity }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  return (
    <footer className="Footer BuurtboerderijFooter">
      <div className="Footer__menu">
        <BuurtboerderijMenuFooter />
      </div>

      <div className="Footer__bottom">
        <Container>
          <div className="row">
            <div className="col-12 Footer__bottom__container">
              <div className="Header__logo">
                <CoreLink
                  to={currentLanguage === 'nl' ? '/' : `/${currentLanguage}`}
                >
                  <div className="Header__logo__wrapper">
                    <div
                      className="Header__logo__img"
                    />
                    <div className="Header__logo__text">
                      {t('general.buurtboerderij')}
                    </div>
                  </div>
                </CoreLink>
              </div>
              <span>&copy; {t('general.buurtboerderij')} {new Date().getFullYear()}</span>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default BuurtboerderijFooter;
